import type { ITableColumnsMetadata } from "app/pages/sneakpeek/types";

export const getColumnsMetaDataFromDataAndSelection = (
    columnNamesFromReturnedData: string[],
    columnsFromSelection: Record<string, ITableColumnsMetadata>,
): ITableColumnsMetadata[] => {
    const columnsFromData = columnNamesFromReturnedData.reduce((acc, name) => {
        return {
            ...acc,
            [name]: {
                field: name,
                name,
                cellTemp: "DefaultCell",
            },
        };
    }, {});
    const aggregatedColumns = { ...columnsFromData, ...columnsFromSelection };

    return Object.values(aggregatedColumns);
};
